@let notificationItem = notification();

@if (statusVisuals(); as statusVisuals) {
  <div
    [class]="statusVisuals.badgeClass"
    class="flex size-7 shrink-0 items-center justify-center rounded-lg"
  >
    <i
      [class]="statusVisuals.iconClass"
      class="text-[15px]/4"
    ></i>
  </div>
}

<div class="flex flex-1 min-w-0 flex-col">
  <ng-content select="[notificationTitle]" />

  <flx-notification-summary [summary]="notificationItem.summary" />

  @if (notificationItem.body) {
    <p
      class="mt-1 text-balance text-xs/[18px] text-neutral-500"
      data-testid="notification-body"
    >
      {{ notificationItem.body }}
    </p>
  }

  @if (notificationItem.hasContext || notificationItem.action) {
    <div class="mt-2 flex items-center gap-1.5">
      @if (notificationItem.hasContext) {
        <flx-notification-context [notification]="notificationItem" />
      }

      @if (notificationItem.action; as action) {
        <button
          (click)="runAction()"
          class="flx-ds ternary small -my-1.5 -mr-3 ml-auto shrink-0"
          clickStopPropagation
          data-testid="notification-action-button"
          flxButton
          type="button"
        >
          {{ action.label }}
        </button>
      }
    </div>
  }
</div>
